import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9;
/* import __COLOCATED_TEMPLATE__ from './history.hbs'; */
import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { action } from "@ember/object";
import { service } from "@ember/service";
import { categoryBadgeHTML } from "discourse/helpers/category-link";
import { sanitizeAsync } from "discourse/lib/text";
import Category from "discourse/models/category";
import Post from "discourse/models/post";
import { iconHTML } from "discourse-common/lib/icon-library";
import I18n from "discourse-i18n";
import TEMPLATE from "./history.hbs";
import { setComponentTemplate } from "@ember/component";
function customTagArray(val) {
  if (!val) {
    return [];
  }
  if (!Array.isArray(val)) {
    val = [val];
  }
  return val;
}
let History = (_class = class History extends Component {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "dialog", _descriptor, this);
    _initializerDefineProperty(this, "site", _descriptor2, this);
    _initializerDefineProperty(this, "currentUser", _descriptor3, this);
    _initializerDefineProperty(this, "siteSettings", _descriptor4, this);
    _initializerDefineProperty(this, "loading", _descriptor5, this);
    _initializerDefineProperty(this, "postRevision", _descriptor6, this);
    _initializerDefineProperty(this, "viewMode", _descriptor7, this);
    _initializerDefineProperty(this, "bodyDiff", _descriptor8, this);
    _initializerDefineProperty(this, "initialLoad", _descriptor9, this);
    this.refresh(this.args.model.postId, this.args.model.postVersion);
  }
  get loadFirstDisabled() {
    return this.loading || this.postRevision?.current_revision <= this.postRevision?.first_revision;
  }
  get loadPreviousDisabled() {
    return this.loading || !this.postRevision.previous_revision || !this.postRevision.previous_revision && this.postRevision.current_revision <= this.postRevision.previous_revision;
  }
  get loadNextDisabled() {
    return this.loading || this.postRevision?.current_revision >= this.postRevision?.next_revision;
  }
  get loadLastDisabled() {
    return this.loading || this.postRevision?.current_revision >= this.postRevision?.next_revision;
  }
  get displayRevisions() {
    return this.postRevision?.version_count > 2;
  }
  get modalTitleKey() {
    return this.args.model.post.version > 100 ? "history_capped_revisions" : "history";
  }
  get previousVersion() {
    return this.postRevision?.current_version ? this.postRevision.current_version - 1 : null;
  }
  get revisionsText() {
    return I18n.t("post.revisions.controls.comparing_previous_to_current_out_of_total", {
      previous: this.previousVersion,
      icon: iconHTML("arrows-alt-h"),
      current: this.postRevision?.current_version,
      total: this.postRevision?.version_count
    });
  }
  get titleDiff() {
    let mode = this.viewMode;
    if (mode === "side_by_side_markdown") {
      mode = "side_by_side";
    }
    return this.postRevision?.title_changes?.[mode];
  }
  get bodyDiffHTML() {
    return this.postRevision?.body_changes?.[this.viewMode];
  }
  async calculateBodyDiff(_, bodyDiff) {
    let html = bodyDiff;
    if (this.viewMode !== "side_by_side_markdown") {
      const opts = {
        features: {
          editHistory: true,
          historyOneboxes: true
        },
        allowListed: {
          editHistory: {
            custom: (tag, attr) => attr === "class"
          },
          historyOneboxes: ["header", "article", "div[style]"]
        }
      };
      html = await sanitizeAsync(html, opts);
    }
    this.bodyDiff = html;
  }
  get previousTagChanges() {
    const previousArray = customTagArray(this.postRevision.tags_changes.previous);
    const currentSet = new Set(customTagArray(this.postRevision.tags_changes.current));
    return previousArray.map(name => ({
      name,
      deleted: !currentSet.has(name)
    }));
  }
  get currentTagChanges() {
    const previousSet = new Set(customTagArray(this.postRevision.tags_changes.previous));
    const currentArray = customTagArray(this.postRevision.tags_changes.current);
    return currentArray.map(name => ({
      name,
      inserted: !previousSet.has(name)
    }));
  }
  get createdAtDate() {
    return moment(this.postRevision.created_at).format("LLLL");
  }
  get displayEdit() {
    return !!(this.postRevision?.can_edit && this.args.model.editPost && this.postRevision?.last_revision === this.postRevision?.current_revision);
  }
  get revertToRevisionText() {
    if (this.previousVersion) {
      return I18n.t("post.revisions.controls.revert", {
        revision: this.previousVersion
      });
    }
  }
  refresh(postId, postVersion) {
    this.loading = true;
    Post.loadRevision(postId, postVersion).then(result => {
      this.postRevision = result;
      this.loading = false;
      this.initialLoad = false;
    });
  }
  hide(postId, postVersion) {
    Post.hideRevision(postId, postVersion).then(() => this.refresh(postId, postVersion));
  }
  show(postId, postVersion) {
    Post.showRevision(postId, postVersion).then(() => this.refresh(postId, postVersion));
  }
  async revert(post, postVersion) {
    try {
      const result = await post.revertToRevision(postVersion);
      this.refresh(post.id, postVersion);
      if (result.topic) {
        post.set("topic.slug", result.topic.slug);
        post.set("topic.title", result.topic.title);
        post.set("topic.fancy_title", result.topic.fancy_title);
      }
      if (result.category_id) {
        post.set("topic.category", await Category.asyncFindById(result.category_id));
      }
      this.args.closeModal();
    } catch (e) {
      if (e.jqXHR.responseJSON?.errors?.[0]) {
        this.dialog.alert(e.jqXHR.responseJSON.errors[0]);
      }
    }
  }
  get editButtonLabel() {
    return `post.revisions.controls.${this.postRevision.wiki ? "edit_wiki" : "edit_post"}`;
  }
  get hiddenClasses() {
    if (this.viewMode === "inline") {
      return this.postRevision?.previous_hidden || this.postRevision?.current_hidden ? "hidden-revision-either" : null;
    } else {
      let result = [];
      if (this.postRevision?.previous_hidden) {
        result.push("hidden-revision-previous");
      }
      if (this.postRevision?.current_hidden) {
        result.push("hidden-revision-current");
      }
      return result.join(" ");
    }
  }
  get previousCategory() {
    if (this.postRevision?.category_id_changes?.previous) {
      let category = Category.findById(this.postRevision.category_id_changes.previous);
      return categoryBadgeHTML(category, {
        allowUncategorized: true,
        extraClasses: "diff-del"
      });
    }
  }
  get currentCategory() {
    if (this.postRevision?.category_id_changes?.current) {
      let category = Category.findById(this.postRevision.category_id_changes.current);
      return categoryBadgeHTML(category, {
        allowUncategorized: true,
        extraClasses: "diff-ins"
      });
    }
  }
  displayInline(event) {
    event?.preventDefault();
    this.viewMode = "inline";
  }
  displaySideBySide(event) {
    event?.preventDefault();
    this.viewMode = "side_by_side";
  }
  displaySideBySideMarkdown(event) {
    event?.preventDefault();
    this.viewMode = "side_by_side_markdown";
  }
  loadFirstVersion() {
    this.refresh(this.postRevision.post_id, this.postRevision.first_revision);
  }
  loadPreviousVersion() {
    this.refresh(this.postRevision.post_id, this.postRevision.previous_revision);
  }
  loadNextVersion() {
    this.refresh(this.postRevision.post_id, this.postRevision.next_revision);
  }
  loadLastVersion() {
    return this.refresh(this.postRevision.post_id, this.postRevision.last_revision);
  }
  hideVersion() {
    this.hide(this.postRevision.post_id, this.postRevision.current_revision);
  }
  permanentlyDeleteVersions() {
    this.dialog.yesNoConfirm({
      message: I18n.t("post.revisions.controls.destroy_confirm"),
      didConfirm: () => {
        Post.permanentlyDeleteRevisions(this.postRevision.post_id).then(() => {
          this.args.closeModal();
        });
      }
    });
  }
  showVersion() {
    this.show(this.postRevision.post_id, this.postRevision.current_revision);
  }
  editPost() {
    this.args.model.editPost(this.args.model.post);
    this.args.closeModal();
  }
  revertToVersion() {
    this.revert(this.args.model.post, this.postRevision.current_revision);
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "dialog", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "site", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "currentUser", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "siteSettings", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "loading", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "postRevision", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "viewMode", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.site?.mobileView ? "inline" : "side_by_side";
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "bodyDiff", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "initialLoad", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _applyDecoratedDescriptor(_class.prototype, "calculateBodyDiff", [action], Object.getOwnPropertyDescriptor(_class.prototype, "calculateBodyDiff"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "displayInline", [action], Object.getOwnPropertyDescriptor(_class.prototype, "displayInline"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "displaySideBySide", [action], Object.getOwnPropertyDescriptor(_class.prototype, "displaySideBySide"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "displaySideBySideMarkdown", [action], Object.getOwnPropertyDescriptor(_class.prototype, "displaySideBySideMarkdown"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loadFirstVersion", [action], Object.getOwnPropertyDescriptor(_class.prototype, "loadFirstVersion"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loadPreviousVersion", [action], Object.getOwnPropertyDescriptor(_class.prototype, "loadPreviousVersion"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loadNextVersion", [action], Object.getOwnPropertyDescriptor(_class.prototype, "loadNextVersion"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loadLastVersion", [action], Object.getOwnPropertyDescriptor(_class.prototype, "loadLastVersion"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hideVersion", [action], Object.getOwnPropertyDescriptor(_class.prototype, "hideVersion"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "permanentlyDeleteVersions", [action], Object.getOwnPropertyDescriptor(_class.prototype, "permanentlyDeleteVersions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showVersion", [action], Object.getOwnPropertyDescriptor(_class.prototype, "showVersion"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "editPost", [action], Object.getOwnPropertyDescriptor(_class.prototype, "editPost"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "revertToVersion", [action], Object.getOwnPropertyDescriptor(_class.prototype, "revertToVersion"), _class.prototype)), _class);
export { History as default };
setComponentTemplate(TEMPLATE, History);